module.exports = __webpack_public_path__ + "static/media/google-plus.1d8cc4a9.png";